import type { Snapshot, Lane } from "../types";
import { laneBrand } from "../lanes";

export function PeakTab({ snap }: { snap: Snapshot | null }) {
  const widgets = [
    {
      label: "Today",
      value: snap ? `$${Math.round(snap.peak.revenue_today_usd).toLocaleString()}` : "—",
      sub: snap ? `${snap.peak.orders_today_count} orders` : "no data",
    },
    {
      label: "AOV",
      value: snap ? `$${snap.peak.aov_usd.toFixed(0)}` : "—",
      sub: snap ? `${(snap.peak.conversion_rate * 100).toFixed(1)}% conv` : "no data",
    },
    {
      label: "Customer queue",
      value: snap?.peak.customer_queue_count ?? "—",
      sub: "Dingo replies",
    },
    {
      label: "Ad spend",
      value: snap ? `${snap.peak.ad_campaigns.length} live` : "—",
      sub: "Milo",
    },
    {
      label: "Checkout",
      value: snap?.peak.checkout_funnel.paid ?? "—",
      sub: snap?.peak.checkout_funnel.broken_step
        ? `broken: ${snap.peak.checkout_funnel.broken_step}`
        : (snap ? "clean" : "no data"),
    },
  ];
  const peakLanes = (snap?.fleet.lanes ?? []).filter((l) => laneBrand(l.id) === "peak");
  return (
    <div className="space-y-5">
      {!snap && (
        <div className="bg-panel border border-edge rounded-md p-3 text-xs text-mist">
          Aggregator not ready · showing soft-empty Peak Peptides view. Panels fill in when the feed reconnects.
        </div>
      )}
      <div className="grid grid-cols-3 gap-3">
        {widgets.map((w) => (
          <div key={w.label} className="bg-panel border border-edge rounded-md p-4 min-h-[120px]">
            <div className="text-mist text-xs uppercase tracking-wide">{w.label}</div>
            <div className="text-3xl mt-2">{w.value}</div>
            <div className="text-mist text-xs mt-1">{w.sub || "No data yet"}</div>
          </div>
        ))}
      </div>
      <PeakLaneStrip lanes={peakLanes} />
    </div>
  );
}

function PeakLaneStrip({ lanes }: { lanes: Lane[] }) {
  if (lanes.length === 0) {
    return (
      <div className="bg-panel border border-edge rounded-md p-3 text-xs text-mist">
        Peak desks: Dingo · Milo — no live state yet.
      </div>
    );
  }
  return (
    <div className="bg-panel border border-edge rounded-md p-3">
      <div className="text-mist text-xs uppercase tracking-wide mb-2">Peak desks</div>
      <div className="grid grid-cols-2 gap-2">
        {lanes.map((l) => (
          <div key={l.id} className="bg-ink/60 border border-edge rounded p-2 text-xs">
            <div className="flex items-center gap-1">
              <span>{l.emoji}</span>
              <span>{l.name}</span>
            </div>
            <div className="text-mist mt-0.5">{l.status}</div>
            <div className="text-mist truncate">{l.last_action_summary || "—"}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
